import React from 'react';
import SourceSelector from './SourceSelector';

interface Props {
  placeholderText?: string;
  onChange: (value: any) => void;
  value: string;
  isSourceCollapsed?: boolean;
  isCsvSource?: boolean;
  sourceAttrOptions: any;
  isDisabled?: boolean;
}

function Container({
  placeholderText,
  onChange,
  value,
  isSourceCollapsed,
  isCsvSource,
  sourceAttrOptions,
  isDisabled,
}: Props) {
  return (
    <SourceSelector
      placeholderText={placeholderText}
      onChange={onChange}
      value={value}
      isSourceCollapsed={isSourceCollapsed}
      isCsvSource={isCsvSource}
      sourceAttrOptions={sourceAttrOptions}
      isDisabled={isDisabled}
    />
  );
}

export default Container;
